import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../../redux/authSlice";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Container, Row, Col, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from "react-toastify";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // Get the token from the URL
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, message } = useSelector((state) => state.auth);
  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await dispatch(resetPassword({ newPassword, token }));

      if (res.payload?.message) {
        toast.success(res.payload.message);
        navigate("/login");
      } else if (res.payload?.error) {
        toast.error(res.payload.error);
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <section>
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Row className="p-4 shadow-lg rounded-4 bg-light" style={{ width: '100%', maxWidth: '400px' }}>
          <Col xxl={12}>
            <h2 className="mb-3 text-center">Reset Password</h2>

            {error && <Alert variant="danger">{typeof error === "string" ? error : error.error}</Alert>}
            {message && <Alert variant="success">{typeof message === "string" ? message : message.message}</Alert>}

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="newPassword">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter your new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : "Reset Password"}
              </Button>
            </Form>
          </Col>

          <Col xxl={12}>
            <div className="mt-3 text-center">
              <Link to="/login" className="mb-2 d-block">Back to Login</Link>
              <span>Don't have an account? </span>
              <Link to="/signup">Sign Up</Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ResetPassword;
